module.exports = __webpack_public_path__ + "static/media/carousel_banner_5.4324561f.png";